module.exports = __webpack_public_path__ + "static/media/img-15.cf750257.jpg";